import React, { Component } from 'react';
import Project from "./PropCalls";
import { Jumbotron, Button, Image,Col,Row,Grid} from 'react-bootstrap';
import portfolio from '../portfolio.jpeg';
import ScrollableAnchor from 'react-scrollable-anchor'

// set desired states in constructor
// change the state with setState
class Statement extends Component {
	render() {
		return (
	 <div className="footer">
		 <h1> LIFE IS BETTER WHEN YOU'RE MAKING THINGS. </h1>
		 </div> 

		);
	}
}


  
export default Statement;


// WEBPACK FOOTER //
// ./src/components/Statement.js